/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { TabCounts } from './tabCounts';

/**
 * ``GET /inbox/summary`` response.
 *
 * The frontend renders the tab strip from this response — counts
 * drive the per-tab badge, while ``has_email`` / ``has_linkedin``
 * drive the conditional channel filter (spec §4.6).
 */
export interface SummaryResponse {
  tab_counts: TabCounts;
  has_email: boolean;
  has_linkedin: boolean;
  /** @minimum 0 */
  total_threads: number;
  /** @minimum 0 */
  total_chats: number;
}
